import type { ComponentType } from 'react';

interface PageModule {
  default: ComponentType;
}

export const reloadOnUpdate =
  <T extends PageModule>(loadFn: () => Promise<T>) =>
  async (): Promise<T> => {
    const isUpdated = window.localStorage.getItem('app-updated');
    if (isUpdated === 'true') {
      window.localStorage.removeItem('app-updated');
      window.location.reload();
      return Promise.reject(new Error('App updated. Reloading...'));
    }
    return loadFn();
  };
